<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">app_id：</label>
          <el-input
            v-model="advertisersQuery.app_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">类型：</label>
          <el-select v-model="advertisersQuery.type" placeholder="请选择">
            <el-option
              v-for="item in accountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="searchContainer">
          <label class="inputLabel">授权信息名称：</label>
          <el-input v-model="advertisersQuery.name" placeholder="请输入内容" />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <el-button
          class="filter-item"
          type="success"
          @click="allocationAccout"
        >授权</el-button>
        <el-button
          icon="el-icon-plus"
          class="filter-item"
          type="warning"
          @click="addadvr"
        >新增</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between"
      >
        <el-table-column prop="type_desc" label="类型" align="center" />
        <el-table-column prop="id" label="id" align="center" width="80" />
        <el-table-column
          prop="app_id"
          label="app_id"
          align="center"
          width="180"
        />
        <el-table-column prop="channel_name" label="视频号名称" align="center" />
        <el-table-column
          prop="stock_screenshot"
          label="股权截图"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              v-if="Object.prototype.toString.call(scope.row.stock_screenshot) === '[object Object]'"
              style="width: 100px; height: 100px"
              :src="scope.row.stock_screenshot.path"
              :preview-src-list="[scope.row.stock_screenshot.path]"
              @click.stop="handleClickStop"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="授权信息名称" align="center" />
        <el-table-column prop="relationship_desc" label="合作关系" align="center" />
        <el-table-column prop="auth_scope_desc" label="授权范围" align="center" />
        <el-table-column
          prop="auth_ttl_day_desc"
          label="过期时间"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="180"
        />
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="edit(scope.row)"> 编辑 </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="eliminate(scope.row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <CodeScanning
      ref="codeScanning"
      :title="
        typeValue === 'QQ'
          ? 'QQ扫码登录'
          : typeValue === '微信'
            ? '微信扫码登录'
            : typeValue
      "
      :myobj="mStyle[typeValue] || {}"
      @reset="reset"
    />
    <el-dialog
      title="批量拉取"
      :visible.sync="dialogVisiblePull"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList ref="pull" @addPull="addPull" />
    </el-dialog>
    <el-dialog
      :title="addAdTitle"
      :visible.sync="dialogVisibleadr"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <addAD ref="addadview" @updata="updata" />
    </el-dialog>
    <el-dialog title="分配账户" :visible.sync="dialogAccout" width="50%">
      <dialogAccout ref="allocation" @callbackbacer="callbackbacer" />
    </el-dialog>
  </div>
</template>

<script>
import dialogAccout from './components/dialogAccout.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  change_name,
  change_app_id,
  advertisers,
  adq_mkt_api_authManage,
  adq_mkt_api_authManageDELETE,
  auth_accountShare
} from '@/api/customer.js'
import { getURL, getBalance } from '@/api/report/accountManagement'
import detailsList from '../../customer/accountList/components/details.vue'
import CodeScanning from '../../customer/accountList/codeScanningLogin/index.vue'
import addAD from './components/addAuthorization.vue'
let that
export default {
  name: 'AccountList',
  components: {
    PaginationRight,
    CodeScanning,
    detailsList,
    addAD,
    dialogAccout
    // AdminAdvertAdd
  },
  filters: {
    // 用于过滤主要运营人员 如果 is_master 为 1 则 relation_name 就是主要运营成员
    filterMaster(currentData) {
      for (let i = 0; i < that.accountType.length; i++) {
        if (that.accountType[i].value === currentData) {
          return that.accountType[i].label
        }
      }
    }
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        name: null,
        type: null, // 广告主名称
        app_id: null, // 广告组名称
        // type: null,
        page: null, // 当前页码
        page_size: null // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      // 账号类型
      accountType: [
        {
          value: 1,
          label: '视频号'
        },
        {
          value: 2,
          label: '广告专用视频号管理'
        },
        {
          value: 3,
          label: '公众号'
        },
        {
          value: 4,
          label: '搜一搜超级品专关键词'
        },
        {
          value: 5,
          label: '小游戏/小程序'
        },
        {
          value: 101,
          label: '企业微信'
        }
      ],
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false,
      dialogVisiblePull: false,
      moneyLoading: false, // 余额加载动画
      mantle: false,
      source: null,
      typeValue: '',
      mStyle: {},
      activeItem: null,
      activeItemId: null,
      activeText: null,
      activeTextid: null,
      dialogVisibleadr: false,
      alone: null,
      dialogAccout: false,
      addAdTitle: null
    }
  },
  created() {
    this.getAdvertiserList()
  },
  beforeCreate() {
    that = this
  },
  methods: {
    allocationAccout() {
      this.dialogAccout = true
      this.$nextTick(() => {
        this.$refs.allocation.sendr()
      })
    },
    async callbackbacer(item) {
      console.log('item:', item)
      try {
        await auth_accountShare(item)
        this.dialogAccout = false
        this.$message.success('授权账户成功')
      } catch (error) {
        console.log('error:', error)
      }
    },
    copy(row) {},
    async addPull(obj) {
      console.log('obj:', obj)
      await advertisers(obj)
      this.$message.success('批量拉取成功')
      this.dialogVisiblePull = false
    },
    handleClose() {
      this.dialogVisiblePull = false
    },
    pullAll() {
      this.dialogVisiblePull = true
      this.$nextTick(() => {
        this.$refs.pull.sendr()
      })
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await change_name({
            id: this.activeItem.id,
            account_name: this.activeText
          })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    async blur2() {
      if (this.activeItemId.consume !== this.activeTextid) {
        try {
          await change_app_id({
            id: this.activeItemId.id,
            app_id: this.activeTextid
          })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItemId = null
          this.activeTextid = null
        }
      }
      this.activeItemId = null
      this.activeTextid = null
    },

    getAdvertiserList() {
      this.loading = true
      adq_mkt_api_authManage(this.advertisersQuery).then((res) => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.count
        this.loading = false
        console.log(22)
        // res.data.list.length > 0 && this.getBalanceData()
        // this.tableData[0].advertiser_relation[0].is_master = 1
      })
    },
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    getURLData(item) {
      this.dialogVisible = true
      if (item === '微信') {
        getURL().then((res) => {
          window.open(res.data.advertiser)
        })
      } else {
        this.typeValue = 'QQ'
        this.$refs.codeScanning.open()
      }
    },
    // 获取用户余额
    getBalanceData() {
      this.moneyLoading = true
      console.log('过来了')
      getBalance({ account_ids: this.accountIdsQuery.toString() }).then(
        (res) => {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr[i] = res.data[i].account
          }
          for (let i = 0; i < this.tableData.length; i++) {
            const index = arr.indexOf(this.tableData[i].account_id)
            if (index !== -1) {
              this.tableData[i].money = res.data[index].balance
            }
          }
          this.accountIdsQuery = []
          this.moneyLoading = false
        }
      )
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {}
      this.getAdvertiserList()
    },
    handleCommand(command, data) {
      switch (command) {
        case 'dataReport':
          this.$router.push({
            name: 'EffectData',
            params: {
              account_id: data.account_id,
              account_name: data.account_name
            }
          })
          break
      }
    },
    reset(callback) {
      callback()
      this.source && this.source()
    },

    // 清除
    eliminate(id) {
      this.$confirm('你确定是否删除账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await adq_mkt_api_authManageDELETE(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getAdvertiserList()
      })
    },
    addadvr() {
      this.addAdTitle = '公众号授权'
      this.dialogVisibleadr = true
      this.$nextTick(() => {
        this.$refs.addadview.send(this.accountType)
      })
    },
    edit(item) {
      this.addAdTitle = '授权信息'
      this.dialogVisibleadr = true
      this.$nextTick(() => {
        this.$refs.addadview.send(this.accountType, item)
      })
    },
    updata() {
      this.dialogVisibleadr = false
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 140px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
